import type { CalculationState } from '../index';

export const calculationTacticExecutionStatusText = (
  state: CalculationState
): CalculationState['calculationTacticExecutionStatusText'] => {
  if (state.calculationTactic.current === 'LOADING')
    return { type: 'LOADING_TEXT', text: 'Retrieving grid information...' };
  if (
    state.calculationTactic.current === 'LOADED' &&
    state.calculationTactic.value.status === 'Completed'
  )
    return { type: 'LOADING_TEXT', text: 'Running calculations...' };

  return { type: 'NO_TEXT' };
};
